import { Suspense, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AbilityContext } from "@context/can";
import { ComponentSpinner } from "@components/spinner";
import { getItemFromStore, isSuperAdminUrl } from "../utility/helpers/utils";
import { PanelDefaultRoute, SuperAdminDefaultRoute } from "./routes";
import themeConfig from "@src/configs/theme-config";

const PrivateRoute = ({ children, route }) => {
    const ability = useContext(AbilityContext);
    const adminToken = getItemFromStore("token");
    const superadminToken = getItemFromStore("token-superadmin");

    let resource = null;
    let action = "null";
    const title = route?.meta?.title || `${themeConfig.app.name}`;

    if (route?.meta) {
        resource = route.meta.resource;
        action = route.meta.action || "null";
    }

    if (!adminToken && !superadminToken) {
        return <Navigate to="/login" />;
    }

    const isSuperAdmin = isSuperAdminUrl();
    const cannotAccess = ability.cannot(action, resource);

    if (superadminToken && cannotAccess) {
        return <Navigate to={SuperAdminDefaultRoute} />;
    }

    if (adminToken) {
        if ((!isSuperAdmin && cannotAccess) || (!superadminToken && isSuperAdmin)) {
            return <Navigate to={PanelDefaultRoute} />;
        }
    }

    document.title = title;

    return (
        <Suspense fallback={<ComponentSpinner className="mt-5 pt-5" />}>
            {children}
        </Suspense>
    );
};

export default PrivateRoute;